export class NotificationUpload {
    static jsonMap = {
        idEntreprise: { key: 'idEntreprise', optional: true },
        idIntervenant: { key: 'idIntervenant', optional: true },
        codeRefSousType: { key: 'codeRefSousType', optional: true, default: '' },
        nomDocument: { key: 'nomDocument', optional: true, default: '' }
    };

    public idEntreprise: number;
    public idIntervenant: number;
    public codeRefSousType: string;
    public nomDocument: string;
}
